module.exports = __webpack_public_path__ + "img/Katarina_home_07.e2d6c45a.jpg";